<div hlmTableContainer>
  <table hlmTable>
    <thead hlmTHead>
      <tr hlmTr>
        <th hlmTh>Kunde</th>
        <th hlmTh>Einrichtung</th>
        <th hlmTh>Zugang deines Kunden</th>
        <th hlmTh class="text-right">Verkauft (30 Tage)</th>
        <th hlmTh class="text-right"><span class="sr-only">Aktionen</span></th>
      </tr>
    </thead>
    <tbody hlmTBody>
      @for (client of clients(); track $index) {
        <tr hlmTr>
          <td hlmTd>
            <span class="font-medium">{{ client.name || 'Noch ohne Namen' }}</span>
            <p hlmMuted class="text-xs">
              @if (client.email) {
                {{ client.email }} ·
              }
              seit {{ client.registered_at | date: 'dd.MM.yyyy' }}
            </p>
          </td>
          <td hlmTd>
            <span hlmBadge [variant]="setup(client).variant">{{ setup(client).label }}</span>
          </td>
          <td hlmTd class="max-w-64 whitespace-normal">
            <span class="text-sm">{{ access(client).label }}</span>
            <p hlmMuted class="text-xs">{{ access(client).hint }}</p>
          </td>
          <td hlmTd class="text-right tabular-nums">
            {{ sales(client) }}
            <p hlmMuted class="text-xs">
              {{ client.vouchers_last_30_days ?? 0 }}
              {{ client.vouchers_last_30_days === 1 ? 'Gutschein' : 'Gutscheine' }}
            </p>
          </td>
          <td hlmTd class="text-right whitespace-nowrap">
            @if (client.managed) {
              <div class="flex justify-end gap-1">
                <button
                  hlmBtn
                  variant="outline"
                  size="sm"
                  type="button"
                  [disabled]="opening() !== null"
                  [attr.aria-busy]="opening() === client.public_id"
                  [attr.aria-label]="'Konto von ' + (client.name || client.email) + ' öffnen'"
                  (click)="openClient.emit(client)">
                  @if (opening() === client.public_id) {
                    <hlm-spinner />
                  } @else {
                    <ng-icon name="lucideExternalLink" data-icon="inline-start" />
                  }
                  Konto öffnen
                </button>
                <button
                  hlmBtn
                  variant="ghost"
                  size="sm"
                  type="button"
                  [hlmDropdownMenuTrigger]="actions"
                  [hlmDropdownMenuTriggerData]="{ $implicit: client }"
                  align="end"
                  [attr.aria-label]="'Weitere Aktionen für ' + (client.name || client.email)">
                  <ng-icon name="lucideEllipsis" />
                </button>
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<ng-template #actions let-client>
  <hlm-dropdown-menu class="w-72">
    @if (client.awaits_claim) {
      <button hlmDropdownMenuItem (click)="resendClaim.emit(client)">
        <ng-icon name="lucideMail" />
        Anmelde-Link erneut schicken
      </button>
      <div hlmDropdownMenuSeparator></div>
    }
    <button hlmDropdownMenuItem variant="destructive" (click)="leave.emit(client)">
      <ng-icon name="lucideUnlink" />
      Nicht mehr betreuen
    </button>
  </hlm-dropdown-menu>
</ng-template>
